import {lazy} from 'react'
import {Route, Switch} from 'react-router-dom'
import {Container} from '../../modules/components'

export enum ManagementRoutesEnum {
    DatatableClients = '/gestao/clientes',
    StoreClient = '/gestao/clientes/cadastro',
    ShowClient = '/gestao/clientes/:uuid',
    DatatableCards = '/gestao/cartoes',
    DatatableGateways = '/gestao/gateways',
}

export default function ManagementsRouter() {
    /*Rotas para Clientes*/
    const DatatableClients = lazy(() => import('../../pages/management/clients/DatatableClients'))
    const ShowClient = lazy(() => import('../../pages/management/clients/ShowClient'))
    const StoreClient = lazy(() => import('../../pages/management/clients/StoreClient'))

    /*Rotas para Cartões*/
    const DatatableCards = lazy(() => import('../../pages/management/cards/DatatableCards'))

    /*Rotas para Gateways*/
    const DatatableGateways = lazy(
        () => import('../../pages/management/gateways/DatatableGateways')
    )

    return (
        <Container loading={false}>
            <Switch>
                <Route path={ManagementRoutesEnum.StoreClient} component={StoreClient} />
                <Route path={ManagementRoutesEnum.ShowClient} component={ShowClient} />
                <Route path={ManagementRoutesEnum.DatatableClients} component={DatatableClients} />

                <Route path={ManagementRoutesEnum.DatatableCards} component={DatatableCards} />

                <Route
                    path={ManagementRoutesEnum.DatatableGateways}
                    component={DatatableGateways}
                />
            </Switch>
        </Container>
    )
}
